import React from "react";
import { cn } from "@/lib/utils";
import { getEnvironmentRibbon } from "@/utils/appEnvironment";

// Build-time constant: resolved once, so the component never re-renders on its own.
const ribbon = getEnvironmentRibbon(import.meta.env);

/**
 * Fixed strip above every page on non-production builds. Its presence sets
 * --env-ribbon-height (index.css), which offsets the page content and every fixed or sticky top element.
 */
const EnvironmentRibbon: React.FC = () => {
  if (!ribbon) return null;

  return (
    <div
      role="status"
      data-env-ribbon
      className={cn(
        "fixed inset-x-0 top-0 z-40 flex h-[var(--env-ribbon-height)] items-center justify-center px-2",
        "select-none text-[11px] font-bold uppercase leading-none tracking-[0.2em]",
        ribbon.className
      )}
    >
      <span className="min-w-0 truncate">{ribbon.label}</span>
    </div>
  );
};

export default EnvironmentRibbon;
